const scrollToTop = () => {
	return window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
}

// Pagination helpers actions
export const handleIncrementPage = (currentPageNumber, setCurrentPageNumber, totalPages, event) => {
	event.preventDefault();
	if (currentPageNumber < totalPages.length) {
		setCurrentPageNumber((currentNumber) => currentNumber + 1);
		scrollToTop();
	}
};
export const handleDecrementPage = (currentPageNumber, setCurrentPageNumber, event) => {
	event.preventDefault();
	if (currentPageNumber > 1) {
		setCurrentPageNumber((currentNumber) => currentNumber - 1);
		scrollToTop();
	}
};

export const handleButtonPageSelect = (buttonNumber, setCurrentPageNumber, event) => {
	event.preventDefault();
	setCurrentPageNumber(buttonNumber);
	scrollToTop();
};